import { TInputCheckboxInstance } from 'widgets/forms/InputCheckbox';
import Widget from 'widgets/Widget';

/**
 * @param AjaxForm Base widget for extending
 * @returns SMS Subscription Mixin class
 */
function SmsSubscriptionMixinClassCreator(AjaxForm: import('widgets/forms/AjaxForm').TAjaxForm) {
    class SmsSubscriptionMixin extends AjaxForm {
        /**
         * @description Handles change event for SMS signup checkbox
         * @param smsSignupCheckbox - instance of TInputCheckboxInstance
         */
        handleSmsSignupChange(smsSignupCheckbox: TInputCheckboxInstance) {
            this.getById('mobilePhone', (phoneField: Widget) => {
                phoneField.toggle(!!smsSignupCheckbox.getValue());
            });
        }
    }

    return SmsSubscriptionMixin;
}

export type TSmsSubscriptionMixin = ReturnType<typeof SmsSubscriptionMixinClassCreator>;

export type TSmsSubscriptionMixinInstance = InstanceType<TSmsSubscriptionMixin>;

export default SmsSubscriptionMixinClassCreator;
